// extracted by mini-css-extract-plugin
export default {"main":"newsItem_main__msM-r","date":"newsItem_date__WhCx5","title":"newsItem_title__ya7KC","hidden":"newsItem_hidden__rniR1","expanded":"newsItem_expanded__ZfgPo"};